import { apiSlice } from 'src/rtk/api/apiSlice';
import * as logBookEntrySetupMasterUrl from 'src/helpers/url_helper';

export const logBookEntrySetupMasterApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ['logBookEntrySetupMasters'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getLogbookEntrySetupMasters: builder.query<APIResponse<LogbookEntrySetupMaster[]>, void>({
        query: () => ({
          method: 'GET',
          url: `${logBookEntrySetupMasterUrl.GET_LOGBOOK_ENTRY_SETUP_MASTERS}`,
        }),
        providesTags: ['logBookEntrySetupMasters'],
      }),

      getCaseTypeFormList: builder.query<APIResponse<LogbookEntrySetupMaster[]>, string>({
        query: (id: any) => ({
          method: 'GET',
          url: `${logBookEntrySetupMasterUrl.GET_CASE_TYPE_FORM}/${id}`,
        }),
        providesTags: ['logBookEntrySetupMasters'],
      }),

      getEntryMasterWiseTarget: builder.query<APIResponse<any>, string>({
        query: (id: any) => ({
          method: 'GET',
          url: `${logBookEntrySetupMasterUrl.GET_ENTRY_MASTER_WISE_TARGET}?logbook_entry_setup_master_id=${id}`,
        }),
        providesTags: ['logBookEntrySetupMasters'],
      }),

      getLogbookEntrySetupMaster: builder.query<APIResponse<LogbookEntrySetupMaster>, string>({
        query: (id) => ({
          url: `${logBookEntrySetupMasterUrl.GET_LOGBOOK_ENTRY_SETUP_MASTER}/${id}`,
          method: 'GET',
        }),
        providesTags: ['logBookEntrySetupMasters'],
      }),

      createLogbookEntrySetupMaster: builder.mutation<APIResponse<LogbookEntrySetupMaster>, LogbookEntrySetupMaster>({
        query: (data) => ({
          url: `${logBookEntrySetupMasterUrl.CREATE_LOGBOOK_ENTRY_SETUP_MASTER}`,
          method: 'POST',
          body: data,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }),
        invalidatesTags: ['logBookEntrySetupMasters'],
      }),

      createTargetSetup: builder.mutation<APIResponse<TargetSetup>, TargetSetup>({
        query: (data) => ({
          url: `${logBookEntrySetupMasterUrl.CREATE_TARGET_SETUP}`,
          method: 'POST',
          body: data,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }),
        invalidatesTags: ['logBookEntrySetupMasters'],
      }),

      updateLogbookEntrySetupMaster: builder.mutation<APIResponse<LogbookEntrySetupMaster>, string>({
        query: (url) => ({
          url: `${logBookEntrySetupMasterUrl.UPDATE_LOGBOOK_ENTRY_SETUP_MASTER}` + url,
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }),
        invalidatesTags: ['logBookEntrySetupMasters'],
      }),

      deleteLogbookEntrySetupMaster: builder.mutation({
        query: (id: string) => ({
          method: 'DELETE',
          url: `${logBookEntrySetupMasterUrl.DELETE_LOGBOOK_ENTRY_SETUP_MASTER}/${id}`,
        }),
        invalidatesTags: ['logBookEntrySetupMasters'],
      }),
    }),
  });

export const {
  useCreateLogbookEntrySetupMasterMutation,
  useCreateTargetSetupMutation,
  useGetLogbookEntrySetupMasterQuery,
  useGetCaseTypeFormListQuery,
  useGetEntryMasterWiseTargetQuery,
  useLazyGetCaseTypeFormListQuery,
  useGetLogbookEntrySetupMastersQuery,
  useUpdateLogbookEntrySetupMasterMutation,
  useDeleteLogbookEntrySetupMasterMutation,
} = logBookEntrySetupMasterApi;
